<template>
	<div class="row">
		<div class="col-md-6 offset-md-3 col-sm-10 offset-sm-1">
			<form id="register-form" role="form" @submit.prevent="onSubmit">
				<h3 class="text-center">Register</h3>
				<div class="form-group">
					<input
							type="email"
							name="email"
							id="email"
							class="form-control"
							placeholder="Email Address"
							value
							v-model="email"
							required
					/>
				</div>
				<div class="form-group">
					<input
							type="password"
							name="password"
							id="password"
							class="form-control"
							placeholder="Password"
							v-model="password"
							required
					/>
				</div>
				<div class="form-group">
					<button type="submit" class="btn btn-success" style="width: 100%" :disabled="isLoading">
						<i v-if="isLoading" class="fa fa-spinner fa-spin"/>
						Register
					</button>
				</div>
				<div class="form-group">
					<div class="row">
						<div class="col-lg-12">
							<div class="text-center">
								<router-link to="/login">
									<a>Login</a>
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import { mapActions } from 'vuex';
	import { accountCreate } from "@/service/accountCreate";
	import { saveAdminToFirebase } from "@/service/firebaseService";
	import { tokenAssociate, tokenGrantKYC } from "@/service/tokenService";

	export default {
		data() {
			return {
				email: '',
				password: '',
				isLoading: false
			}
		},
		methods: {
			...mapActions(['clearMessage', 'addMessage', 'registerByEmail', 'saveAccount']),
			async onSubmit() {
				this.isLoading = true
				let data = {
					email: this.email,
					password: this.password
				}
				try {
					await this.registerByEmail(data)
					const account = await accountCreate(this.email)
					if(this.email === 'admin@gmail.com') {
						await saveAdminToFirebase(account);
						this.$store.commit('setAdmin', account)
						this.clearMessage();
						await this.$router.push({ name: 'admin' });
						this.isLoading = false
					} else {
						await this.saveAccount(account);
						await this.$store.dispatch('updateAccounts', account.wallet);
						const token = this.$store.getters.getAdminToken;
						await this.associateToken(account, token);
						await this.grantKYC(account, token);
						this.clearMessage();
						await this.$router.push({ name: 'mainpage' });
						this.isLoading = false
					}

				} catch (error) {
					let message_obj = {
						message: error.message,
						messageClass: "danger",
						autoClose: true
					}
					await this.addMessage(message_obj);
					console.log(message_obj);
					this.isLoading = false;
				}
			},
			async associateToken(account, token) {
				const status = await tokenAssociate(token.tokenId, account);

				if(!status) {
					let message_obj = {
						message: "Associate Token failed",
						messageClass: "danger",
						autoClose: true
					}
					await this.addMessage(message_obj);
				}

			},
			async grantKYC(account, token) {
				const instruction = {
					accountId: account.accountId,
					tokenId: token.tokenId
				}

				const status = await tokenGrantKYC(instruction);
				if(!status) {
					let message_obj = {
						message: "grant KYC failed",
						messageClass: "danger",
						autoClose: true
					}
					await this.addMessage(message_obj);
				}
			}
		},
		created() {
			console.log('Register created');
			console.log(this.$store.getters.getAccounts);
		}
	}
</script>
